import { AllPatchNoteData } from './AllPatchNoteData.ts';
import { AnnouncementView } from './AnnouncementView.ts';
import { PatchNoteView } from './PatchNoteView.ts';
export class UIPatchNotes {
    constructor(sidebar){
        const pnContainer = document.getElementById('patch_note_container');
        const pnData = new AllPatchNoteData();
        const announcementContainer = document.getElementById('announcement_container');
        const announcements = pnData.getAnnouncements();
        new AnnouncementView({
            key: 'strings:popups.patchNote.announcement'
        }, announcements, announcementContainer, 'pn-content', 'pn-header-div', 'pn-body-div');
        for (const pn of pnData.getAll()){
            new PatchNoteView(pn, pnContainer, sidebar, 'pn-content', 'pn-header-div', 'pn-body-div');
        }
    }
}
